import React, { useEffect, useRef } from 'react';

const AudioWaveform = ({ isRecording, audioLevel = 0 }) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!isRecording) {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      return;
    }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    let time = 0;

    const animate = () => {
      // Clear canvas
      ctx.clearRect(0, 0, width, height);

      // Set up wave properties
      const waveCount = 3;
      const baseAmplitude = 8;
      const frequency = 0.02;
      const speed = 0.05;

      // Draw multiple waves
      for (let wave = 0; wave < waveCount; wave++) {
        ctx.beginPath();
        ctx.strokeStyle = `rgba(59, 130, 246, ${0.3 + wave * 0.2})`; // Blue with opacity
        ctx.lineWidth = 2;

        // Draw wave with real audio level influence
        for (let x = 0; x < width; x++) {
          // Use real audio level to modulate the wave amplitude
          const audioInfluence = Math.min(audioLevel / 50, 2); // Normalize audio level
          const dynamicAmplitude = baseAmplitude * (1 + audioInfluence);
          
          const y = height / 2 + 
            Math.sin(x * frequency + time + wave * Math.PI / 3) * dynamicAmplitude +
            Math.sin(x * frequency * 2 + time * 1.5) * (dynamicAmplitude / 2);
          
          if (x === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        }

        ctx.stroke();
      }

      time += speed;
      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isRecording, audioLevel]);

  if (!isRecording) return null;

  return (
    <div className="audio-waveform">
      <canvas
        ref={canvasRef}
        width={200}
        height={40}
        style={{
          display: 'block',
          borderRadius: '4px',
          background: 'rgba(59, 130, 246, 0.1)'
        }}
      />
    </div>
  );
};

export default AudioWaveform;
